import {
  Component,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import {
  RouterService,
  utilsFactory,
} from '@lib/gc-common';
import { RESPONSE } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'mip-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  errorMessage = null;

  constructor(
    private routerService: RouterService,
    @Optional()
    @Inject(RESPONSE)
    private response: any,
  ) {}

  async ngOnInit() {
    try {
      const { queryParams } = await this.routerService.getRouteObject();

      if (queryParams.e) {
        this.errorMessage = utilsFactory.atob(queryParams.e);
      }

      if (this.response) {
        this.response.status(404);
      }
    } catch (e) {
      console.error('not-found.component->ngOnInit(): ERROR', e);
    }
  }
}
